import { useCallback } from "react";

import { useConfLists } from "src/providers/ConfListsProvider";
import { PropertyValue } from "src/types/property";

import { useFormatTypedValue } from "../useFormatTypedValue";

export const useFormatPropertyValue = () => {
  const formatTypedValue = useFormatTypedValue();
  const confLists = useConfLists();

  const formatPropertyValue = useCallback(
    (property: PropertyValue) => {
      if (property.value.type === "code" && property.property.confListCode) {
        const confList = confLists.find((cl) => cl.code === property.property.confListCode);
        const element = confList?.elements.find((el) => el.code === property.value.value);
        if (element) return element.name;
      }
      return formatTypedValue(property.value);
    },
    [formatTypedValue, confLists]
  );

  return formatPropertyValue;
};
